// §26.3 / §9.1 — Connections as an in-process app. Gated (D-200): a guest never sees it, because
// §26.9 puts the whole social layer behind a session.
//
// Not lazy. Every Arcade title is (D-247) because a game is 10–54 KB of engine nobody may open;
// this is a roster and a link, and it is also where an invitation is *answered* — a chunk fetch
// between "someone suggested a game" and the window opening is latency at the one moment §26.4
// exists to protect.
import type { InProcessApp, SocialShellAccess } from '@hangar/shared';
import { createRoot, type Root } from 'react-dom/client';
import { Connections } from './Connections';

export function createConnectionsApp(access: SocialShellAccess): InProcessApp {
  const roots = new WeakMap<HTMLElement, Root>();
  return {
    id: 'connections',
    name: 'Connections',
    icon: { glyph: 'users', hue: 210 },
    keywords: ['friends', 'people', 'roster', 'invite', 'presence', 'social'],
    requiresAuth: true,
    window: { width: 460, height: 560, minWidth: 340, minHeight: 320, multiWindow: false },
    mount(container) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Connections access={access} />);
    },
    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
